module.exports = __webpack_public_path__ + "static/media/logoNik.3e811d81.svg";